import type { FC } from 'react';
import {
  Card,
  Table,
  TableHead,
  TableRow,
  Box,
  TableBody,
  TableCell,
  TableFooter,
  TablePagination,
} from '@material-ui/core';
import Title from 'src/components/admin/Title';
import Scrollbar from 'src/components/admin/Scrollbar';
import TableCellHeaderBasic from 'src/components/global/TableCellHeaderBasic';
import { numberToMillons } from 'src/utils/functions';

interface PropsSeguimientoFactFuvex {
  content: {
    data: any;
    resume: { operaciones: number; facturacion: number; meta: number };
    pages: { total: number; current: number; limit: number };
  };
  handleChangePage: (event: unknown, page: number) => Promise<void>;
  handleChangeRowsPerPage: (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => Promise<void>;
}

const SeguimientoFactJefe: FC<PropsSeguimientoFactFuvex> = ({
  content,
  handleChangePage,
  handleChangeRowsPerPage,
}) => {
  const title = 'Avance Meta por Jefe de Relación, En unidades, MM de PEN';
  const headers = [
    'Jefa Relación',
    'N° Op.',
    'Facturación',
    'Meta',
    'Aporte de Fact.',
  ];

  return (
    <Box pt={2}>
      <Title title={title} />
      <Card>
        <Scrollbar>
          <Table size="small" className="zoomin">
            <TableHead>
              <TableRow>
                {headers.map((header, index) => (
                  <TableCellHeaderBasic
                    key={header}
                    align={index !== 0 ? 'right' : 'left'}
                  >
                    {header}
                  </TableCellHeaderBasic>
                ))}
                <TableCellHeaderBasic />
              </TableRow>
            </TableHead>
            <TableBody>
              {content.data.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>{item.jfr}</TableCell>
                  <TableCell align="right">{item.operaciones}</TableCell>
                  <TableCell align="right">
                    {numberToMillons(item.facturacion)}
                  </TableCell>
                  <TableCell align="right">
                    {numberToMillons(item.meta)}
                  </TableCell>
                  <TableCell align="right">
                    {item.aporte}
                    %
                  </TableCell>
                  <TableCell align="right">
                    <img
                      src={`/static/images/${item.semaforo}.png`}
                      alt={item.semaforo}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableHead>
              <TableRow>
                <TableCellHeaderBasic>Total</TableCellHeaderBasic>
                <TableCellHeaderBasic align="right">
                  {content.resume.operaciones}
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="right">
                  {numberToMillons(content.resume.facturacion)}
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="right">
                  {numberToMillons(content.resume.meta)}
                </TableCellHeaderBasic>
                <TableCellHeaderBasic />
                <TableCellHeaderBasic />
              </TableRow>
            </TableHead>
            <TableFooter>
              <TableRow>
                <TablePagination
                  backIconButtonProps={{
                    title: 'Página anterior',
                  }}
                  nextIconButtonProps={{
                    title: 'Página siguiente',
                  }}
                  rowsPerPageOptions={[5, 10, 15, 20]}
                  labelRowsPerPage="Registros por página"
                  labelDisplayedRows={({ from, to, count }) => `${from} al ${to} de ${count}`}
                  count={content.pages.total}
                  page={content.pages.current}
                  rowsPerPage={content.pages.limit}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </Scrollbar>
      </Card>
    </Box>
  );
};

export default SeguimientoFactJefe;
